__turbopack_context__.v({
  "buttons": "TargetOffsetModal-module___vsT3q__buttons",
  "closeButton": "TargetOffsetModal-module___vsT3q__closeButton",
  "copyButton": "TargetOffsetModal-module___vsT3q__copyButton",
  "loadingContainer": "TargetOffsetModal-module___vsT3q__loadingContainer",
  "modalBody": "TargetOffsetModal-module___vsT3q__modalBody",
  "restartButton": "TargetOffsetModal-module___vsT3q__restartButton",
  "resultColumn": "TargetOffsetModal-module___vsT3q__resultColumn",
  "resultLabel": "TargetOffsetModal-module___vsT3q__resultLabel",
  "resultValue": "TargetOffsetModal-module___vsT3q__resultValue",
  "resultsContainer": "TargetOffsetModal-module___vsT3q__resultsContainer",
  "title": "TargetOffsetModal-module___vsT3q__title",
  "tooltipTarget": "TargetOffsetModal-module___vsT3q__tooltipTarget",
  "wrapper": "TargetOffsetModal-module___vsT3q__wrapper",
});
